module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1puU2"))).then(() => parcelRequire('8rm4T'));